<template>
  <div class="moke-list" style="width: 100%;">
    <div
      class="moke-image"
      :style="`background-image: url(${aliImage}) !important`"
    >
      <div class="font-bold font-20">{{title}}</div>
    </div>
    <template v-if="aliData.length">
      <div
        v-for="(s, index) in aliData"
        :key="`moke-list${index}`"
      >
        <tk-flex middle class="p-15 full-width">
          <tk-image style="flex-shrink: 0;" :width="28" :height="28" :src="s.img"/>
          <div class="m-l-12">
            <div class="font-14 font-bold">{{s.title}}</div>
            <div class="font-12 text-gray m-t-8">{{s.tooltip}}</div>
          </div>
        </tk-flex>
        <div class="moke-line" v-if="index < aliData.length - 1 "></div>
      </div>
      <slot></slot>
      <div style="height: 8px;"></div>
    </template>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  props: {
    aliImage: {
      type: String
    },
    title: {
      type: String,
      default: '阿里云OSS服务'
    },
    aliData: {
      type: Array
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
  .moke-list {
    width: 100%;
    background-color: #fffffb;
    border-radius: 5px;
    overflow: hidden;
    .moke-image {
      width: 100%;
      height: 80px;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: 50%;
      object-fit: cover;
      padding: 33px 25px 14px;
      &>div {
        font-size: 22px;
        color: #212121;
      }
    }
    .moke-line {
      width: 100%;
      height: 1px;
      background-color: #eaeaea;
    }
  }
</style>
